import { environment } from '../../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('FeatureService', FeatureService);

  FeatureService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'TranslationModalService',
    'WindowModalService',
  ];

  function FeatureService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    TranslationModalService,
    WindowModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'features';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getFeatures: getFeatures,
      getFeature: getFeature,
      saveFeature: saveFeature,
      openFeatureTranslations: openFeatureTranslations,
      openFeatureDetailModal: openFeatureDetailModal,
      groupFeaturesByCategory: groupFeaturesByCategory,
      setFeaturesSelected: setFeaturesSelected,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filter = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filter;
    }

    function getFeatures(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getFeature(id, language) {
      var params = { lang: null };

      if (language) {
        params.lang = language;
      }

      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        params,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveFeature(item, language) {
      var itemAddedMsg = $translate('NEW_ADDED_FEATURE');
      var itemAddedFlashMsg =
        $translate('FEATURE_ADDED_MSG') + ' ' + $translate('REMEMBER_ADD_TRANSLATIONS');
      var itemModifiedMsg = $translate('MODIFIED_FEATURE');

      var method = item.id ? 'put' : 'post';
      var url = item.id ? apiUrl + '/' + item.id : apiUrl;

      var lang = language ? language : config.DEFAULT_CONTENT_LANGUAGE;

      function success(response) {
        var msg = item.id ? itemModifiedMsg : itemAddedMsg;
        utils._successMsg(msg);

        if (!item.id) {
          // Create
          utils._setFlashMessage(itemAddedFlashMsg);
        }

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(method, url, { feature: item, lang: lang }, success, failure);
    }

    function openFeatureTranslations(item, additionalLanguages) {
      var template = './app/ajs/admin/features/modals/feature-detail-translation.html';

      var modalParams = {
        title: item.name,
        item: item,
        additionalLanguages: additionalLanguages,
      };

      var initializeCallback = function (itemId, language) {
        return getFeature(itemId, language).then(function (data) {
          return data;
        });
      };

      var confirmCallback = function (item, language) {
        return saveFeature(item, language).then(function (data) {
          if (!data.status) {
            return data.response;
          }

          return false;
        });
      };

      TranslationModalService.open(template, modalParams, initializeCallback, confirmCallback);
    }

    function openFeatureDetailModal(item, additionalLanguages, mode, featureCategories) {
      var templateUrl = './app/ajs/admin/features/modals/feature-detail-modal.html';

      var originalItem = angular.copy(item);

      var modalParams = {
        title: 'FEATURE_DETAILS',
        item: originalItem,
        additionalLanguages: additionalLanguages,
        parentOptions: featureCategories,
        mode: mode,
      };

      var confirmCallback = function (selectedItem) {
        item.name = selectedItem.name;
        item.description = selectedItem.description;
        item.type = selectedItem.type;
        item.visible_as_addon = selectedItem.visible_as_addon;

        item.feature_category_id = selectedItem.feature_category_id;
        item.feature_category.name = selectedItem.feature_category.name;

        return utils.itemListChanged(selectedItem.id);
      };

      WindowModalService.open(templateUrl, modalParams, confirmCallback);
    }

    function groupFeaturesByCategory(items) {
      var featureCategoryList = [];
      items.forEach(function (item) {
        var featureCategoryId = item.feature_category_id;

        if (!featureCategoryList[featureCategoryId]) {
          featureCategoryList[featureCategoryId] = {
            id: item.feature_category.id,
            name: item.feature_category.name,
            description: item.feature_category.description,
            features: [],
          };
        }

        var value = (item.value = item.type === 'quantity' ? 1 : false);

        var feature = {
          id: item.id,
          name: item.name,
          description: item.description,
          name_key: item.name_key,
          type: item.type,
          visible_as_addon: item.visible_as_addon,
          feature_category_id: featureCategoryId,
          value: value, // Form feature
        };

        featureCategoryList[featureCategoryId].features.push(feature);
      });

      var array = [];
      for (var key in featureCategoryList) {
        if (featureCategoryList.hasOwnProperty(key)) {
          var feature = featureCategoryList[key];
          array.push(feature);
        }
      }

      return array;
    }

    function setFeaturesSelected(option, featureOptions, field, selectedPlanFeature) {
      var featuresSelected = [];

      function appendToArray(item, feature) {
        //if (typeof(feature.value) === 'boolean'){ // not working with nulls
        if (feature.type === 'available') {
          item['available'] = feature.value || false;
        } else {
          item['total_units'] = feature.value;
        }

        item['name_key'] = feature.name_key;

        featuresSelected.push(item);
      }

      if (option === 'create') {
        // Create
        featureOptions.forEach(function (category) {
          category.features.forEach(function (feature) {
            var item = {};

            item[field] = feature.id;

            appendToArray(item, feature);
          });
        });
      } else {
        // Edit
        for (var key in selectedPlanFeature) {
          if (selectedPlanFeature.hasOwnProperty(key)) {
            var feature = selectedPlanFeature[key];

            var item = {
              id: null,
            };

            if (feature.id) {
              // update
              item.id = feature.id; // feature_addon id
            }

            item[field] = feature[field];

            appendToArray(item, feature);
          }
        }
      }

      return featuresSelected;
    }
  }
})();
